import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { memo } from "react";
import { cn } from "../../tailwind-utils";
import * as css from "./list-classic-node.module.css";

export const BulletedListElement = memo(function BulletedListElement(
  props: PlateElementProps,
) {
  return (
    <PlateElement {...props} as="ul" className={cn(css.ul, props.className)}>
      {props.children}
    </PlateElement>
  );
});

export const NumberedListElement = memo(function NumberedListElement(
  props: PlateElementProps,
) {
  return (
    <PlateElement {...props} as="ol" className={cn(css.ol, props.className)}>
      {props.children}
    </PlateElement>
  );
});

export const ListItemElement = memo(function ListItemElement(
  props: PlateElementProps,
) {
  return (
    <PlateElement {...props} as="li" className={cn(css.li, props.className)}>
      {props.children}
    </PlateElement>
  );
});

export const ListItemContentElement = memo(function ListItemContentElement(
  props: PlateElementProps,
) {
  return <PlateElement {...props}>{props.children}</PlateElement>;
});
